import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import { darken, getLuminance } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    borderRadius: '20px',
    fontSize: 16,
    padding: '4px 16px',
  },
  leftIcon: {
    fill: '#FFFFFF',
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing.unit,
    },
  },
});
const SocialButtonComponent = ({ children, classes, className, icon: Icon, ...props }) => (
  <Button variant="contained" className={classNames(classes.root, className)} {...props}>
    <Icon className={classes.leftIcon} />
    <span className={classes.label}>{children}</span>
  </Button>
);
SocialButtonComponent.propTypes = {
  children: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
};
const SocialButtonStyled = withStyles(styles)(SocialButtonComponent);

export const SocialButton = ({ errors, ...props }) => {
  const hasError = errors && errors.provider === props.children;

  if (hasError) {
    return (
      <Tooltip open title={`Unexpected error with ${props.children}.`}>
        <SocialButtonStyled disabled {...props} />
      </Tooltip>
    );
  }

  return <SocialButtonStyled {...props} />;
};

export const socialClasses = (color) => ({
  backgroundColor: color,
  color: getLuminance(color) > 0.5 ? '#000' : '#fff',
  margin: '5px',
  '&:hover': {
    backgroundColor: darken(color, 0.1),
  },
});
